import { useEffect, useRef } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

export function useAnalyticsTracker(userId, pathnameOverride) {
    const startTimeRef = useRef(Date.now());
    const durationSentRef = useRef(false);

    useEffect(() => {
        const pageUrl = pathnameOverride || window.location.pathname;
        startTimeRef.current = Date.now();
        durationSentRef.current = false;

        fetch(`${API_BASE_URL}/api/track/view`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ url: pageUrl, userId: userId ?? null }),
            keepalive: true
        }).catch((err) => console.warn('Tracking view failed (ignored):', err));

        function sendDuration() {
            if (durationSentRef.current) return;
            durationSentRef.current = true;
            const duration = Math.round((Date.now() - startTimeRef.current) / 1000);
            if (duration <= 0 || duration > 3600) return;

            const payload = JSON.stringify({ url: pageUrl, userId: userId ?? null, duration });
            navigator.sendBeacon(`${API_BASE_URL}/api/track/duration`, payload);
        }

        function handleVisibilityChange() {
            if (document.visibilityState === 'hidden') sendDuration();
        }

        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('pagehide', sendDuration);

        return () => {
            sendDuration();
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('pagehide', sendDuration);
        };
    }, [userId, pathnameOverride]);
}